import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "./Contexts/AppContext";
import LoginPage from "./Pages/LoginPage";
import { OAuth2HandlerPage } from "Pages/OAuth2HandlerPage";
import { QueryClient, QueryClientProvider } from "react-query";
import { ProtectedRoute } from "Routes/ProtectedRoute";
import AvatarsPage from "Pages/AvatarsPage";
import ScenesPage from "Pages/ScenesPage";
import { Init } from "Components/Init";

const queryClient = new QueryClient();

function App() {
    return (
        <AppProvider>
            <QueryClientProvider client={queryClient}>
                <Init />
                <BrowserRouter>
                    <Routes>
                        <Route index element={<ScenesPage />} />
                        <Route path="login" element={<LoginPage />} />
                        <Route path="auth" element={<OAuth2HandlerPage />} />
                        <Route path="avatars" element={<ProtectedRoute />}>
                            <Route index element={<AvatarsPage />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </QueryClientProvider>
        </AppProvider>
    );
}

export default App;
